// app/javascript/controllers/topmenu_dropdown_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "chevronDown", "chevronUp", "button"]

  connect() {
    this.open = false
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.open ? this.close() : this.openMenu()
  }

  openMenu() {
    this.open = true
    this.menuTarget.classList.remove("hidden")
    this.chevronDownTarget.classList.add("hidden")
    this.chevronUpTarget.classList.remove("hidden")
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "true")
    }
  }

  close() {
    this.open = false
    this.menuTarget.classList.add("hidden")
    this.chevronDownTarget.classList.remove("hidden")
    this.chevronUpTarget.classList.add("hidden")
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "false")
    }
  }

  // called on mouseleave of the wrapper
  maybeClose(event) {
    const toEl = event.relatedTarget
    if (toEl && this.element.contains(toEl)) return
    this.close()
  }

  clickOutside(event) {
    if (!this.open) return
    if (this.element.contains(event.target)) return
    this.close()
  }
}
